import StoreFinderPage, {
  getServerSideProps as _getServerSideProps
} from '#src/store-finder/tactical/store-finder-page'
import {
  clickAndCollectShutter,
  clickAndCollectShutterPathUK
} from '#constants'
import withSSRLoggingContext from '#src/common/lib/with-ssr-logging-context'
import { withGtmPageProps } from '#src/common/lib/with-gtm-page-props'
import { withServiceShutter } from '#src/common/lib/with-service-shutter'
import { STORE_FINDER_PAGE } from '#src/common/page-config/page-config'
import { pipe } from 'ramda'

export const getServerSideProps = pipe(
  withSSRLoggingContext,
  withGtmPageProps(STORE_FINDER_PAGE),
  withServiceShutter(clickAndCollectShutter, `/${clickAndCollectShutterPathUK}`)
)(async ctx => {
  const { routeShuttered, redirect } = ctx.shutter || {}
  return routeShuttered ? { redirect } : _getServerSideProps(ctx)
})

export default StoreFinderPage
